import React, { useState, useEffect, useRef } from 'react'
import { _Api } from '../../api/_call'
import { useTranslation } from 'react-i18next';
import KycStatusIcon from 'admin/customers/KycStatusIcon';
import { _WarrantyApi } from 'admin/api/_call';
import { toast } from 'react-toastify';
const CustomerSearchModal = (props) => {
  const { t } = useTranslation();
  const { setSearchid, newcustomer, setCreatecustomer,kycIntegrate, setKycIntegrate} = props
  const [searchvalue, setSearchvalue] = useState()
  const [searchlist, setSearchlist] = useState('')
  const [show, setShow] = useState(false)
  const debounceRef = useRef(null)
  // const [kycIntegrate, setKycIntegrate] = useState();
  const [kycLoading, setKycLoading] = useState(false);
  const kycPollRef = useRef(null);
  // const callsearchlist = async (event) => {
  //   try {
  //     const postdata = {
  //       search: event.target.value,
  //     }
  //     let resSearchlist = await _Api(postdata, `api/v1/App/customer/find`)
  //     if (resSearchlist.code === 200) {
  //       setSearchlist(resSearchlist.data)
  //     }
  //   } catch (err) {
  //     console.log(err, 'err')
  //   }
  // }

  const fetchOndatoUrl = async (id) => {
    console.log(id, "id");
    try {
      setKycLoading(true);
      let res = await _WarrantyApi({ id }, `api/v1/APP/profile/create-kyc`);
      if (res?.success === true) {
        window.open(res?.data?.url, "_blank", "noreferrer");
        // startKycPolling(id);
      } else {
        toast.error(
          res?.message ||
            res?.error ||
            "Something went wrong. Please try again.",
        );
      }
    } catch (err) {
      console.log(err, "err");
      toast.error(
        err?.response?.data?.message ||
          err?.message ||
          "Failed to initiate KYC. Please try again.",
      );
    } finally {
      setKycLoading(false);
    }
  };
  const handleKyc = (result) => {
    console.log(result, "rerere");
    if (
      !kycLoading &&
      result?.kycStatus !== "Approved" &&
      result?.kycStatus !== "Completed"
    ) {
      fetchOndatoUrl(result?._id);
    }
  };

  const callsearchlist = async (search) => {
    try {
      if (!search.trim()) {
        setSearchlist([])
        return
      }
  
      const postdata = {
        search,
      }
  
      const resSearchlist = await _Api(postdata, `api/v1/App/customer/find`)
  
      if (resSearchlist.code === 200) {
        setSearchlist(resSearchlist.data);
        setKycIntegrate(resSearchlist?.kycIntegration?.status);
      }
    } catch (err) {
      console.log(err, "err")
    }
  }
  const getsearchvalue = (event) => {
    const row = event.currentTarget
    var value = row.getAttribute('data-search')
    var valueid = row.getAttribute('data-id')
    setSearchvalue(value)
    setShow(false)
    setSearchid(valueid)
  }
  useEffect(() => {
    if (newcustomer) {
      setSearchid(newcustomer?.id)
      setSearchvalue(newcustomer?.name)
    }
  // eslint-disable-next-line
  }, [newcustomer])
  useEffect(() => {
    return () => {
      if (debounceRef.current) {
        clearTimeout(debounceRef.current)
      }
    }
  }, [])
  const kycCustomer = { ...newcustomer, _id: newcustomer?.id };
  
  return (
    <div className="main-body-top-status-bar-filter position-relative ps-1">

{newcustomer?.id ? (
          <div
            style={{
              display: "flex",
              paddingLeft: "20px",
              gap: "10px",
              alignItems: "center",
            }}
          >
            <span
              style={{
                whiteSpace: "nowrap",
                flexShrink: 0,
              }}
            >
              {searchvalue?.length > 31
                ? `${searchvalue.substring(0, 33)}...`
                : searchvalue}
            </span>
            {kycIntegrate === 1 &&
              newcustomer?.id && (
                <div style={{ paddingRight: "8px" }}>
                  <span
                    onClick={() => handleKyc(kycCustomer)}
                    style={{
                      color: "#000",
                      cursor:
                        kycCustomer?.kycStatus === "Approved" ||
                        kycCustomer?.kycStatus === "Completed"
                          ? "default"
                          : "pointer",
                      padding: "5px 0 0",
                      fontSize: "14px",
                    }}
                  >
                    <KycStatusIcon
                      status={kycCustomer?.kycStatus}
                      expireDate={kycCustomer?.kycExpireDate}
                    />
                  </span>
                </div>
              )}
          </div>):(
            <div className="placeholder-up-input w-100 h-100 ps-2">
            <input
              type="text"
              value={searchvalue ? searchvalue : ""}
              className="main-body-top-status-bar-filter-input placeholder-up-input-field form-control position-relative border-start-0 ps-0 text-truncate bg-transparent"
              placeholder=""
              // onChange={(e) => {
              //   setSearchvalue(e.target.value)
              //   setShow(true)
              //   callsearchlist(e)
              // }}
              onChange={(e) => {
                const value = e.target.value
              
                setSearchvalue(value)
                setShow(true)
              
                if (debounceRef.current) {
                  clearTimeout(debounceRef.current)
                }
              
                debounceRef.current = setTimeout(() => {
                  callsearchlist(value)
                }, 300)
              }}
            />
            <label className="placeholder-up-input-label">{t("Customer")}</label>
          </div>
          )}
      <button
        className="main-body-top-status-bar-filter-search"
        data-bs-toggle="modal"
        data-bs-target="#customerSearchDetailModal"
      >
        <i onClick={() => setCreatecustomer(false)} className="fa fa-search" aria-hidden="true"></i>
      </button>
      {show && searchvalue !== '' && searchlist.length > 0 ? (
        <div className="dropdown_search_list">
          <ul className="dropdown_search_list-ul">
            {searchlist
              ? searchlist.map((result, key) => {
                const mobile = result?.mobile != null ? String(result.mobile).trim() : ''
                const countryName =
                  result?.country_name != null ? String(result.country_name).trim() : ''
                  const cityName =
                  result?.city != null ? String(result.city).trim() : "";
                const showPhoneLine = Boolean(mobile && countryName)
                return (
                  <li
                    data-search={result?.name ? result?.name : ''}
                    data-id={result?._id}
                    onClick={(e) => { getsearchvalue(e) }}
                    className="dropdown_search_list-ul-li"
                    key={key}
                  >
                      <div
                          style={{
                            display: "flex",
                            gap: "10px",
                            alignItems: "center",
                          }}
                        >
                    <div className="dropdown_search_list-ul-li-name">
                      {result?.name ? result?.name : ''}
                    </div>
                    {kycIntegrate === 1 &&(
                              <div>
                                <span
                                  onClick={() => handleKyc(result)}
                                  style={{
                                    color: "#000",
                                    cursor:
                                      result?.kycStatus === "Approved" ||
                                      result?.kycStatus === "Completed"
                                        ? "default"
                                        : "pointer",
                                    padding: "5px 0 0",
                                    fontSize: "14px",
                                  }}
                                >
                                  <KycStatusIcon
                                    status={result?.kycStatus}
                                    expireDate={result?.kycExpireDate}
                                  />
                                </span>
                              </div>
                            )}
                            </div>
                    {showPhoneLine ? (
                      <div className="dropdown_search_list-ul-li-meta">
                        {cityName}, {countryName} · {mobile}
                      </div>
                    ) : null}
                  </li>
                )
              })
              : ''}
          </ul>
        </div>
      ) : (
        ''
      )}
    </div>
  )
}

export default CustomerSearchModal
